import React from "react";
import "./Footer.css";
import Button from "../Button/Button";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="divWrapper" id="footer">
        <div className="arvrcontainer">
          <div className="footer-content">
            <h2>Ready to Build With Us?</h2>
            <p>
              No matter if you require <strong>augmented reality development services</strong> on
              mobile platforms or scalable enterprise VR systems, we're here to
              assist in bringing your ideas to life seamlessly and
              strategically.
            </p>
            {/* <div onClick={scrollToTop}><Button  text={'Let’s Talk'} arrowColor={'black'}/></div> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
